// Copyright (c) Microsoft. All rights reserved.

import { FC, useState } from 'react';
import { Button, Tooltip, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { ClipboardCodeRegular, DismissCircleRegular } from '@fluentui/react-icons';
import { SettingsDialog } from './settings-dialog/SettingsDialog';

export const useClasses = makeStyles({
    root: {
        marginRight: tokens.spacingHorizontalXL,
    },
    persona: {
        ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingVerticalMNudge),
        overflowWrap: 'break-word',
    },
    settingsButtonWithoutAuth: {
        color: 'white',
    },
    logsButton: {
        borderRadius: tokens.borderRadiusMedium,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            border: `1px solid ${tokens.colorNeutralStroke1}`,
        },
    },
    logsButtonActive: {
        color: tokens.colorBrandForeground1,
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        '&:hover': {
            border: `1px solid ${tokens.colorNeutralStroke1}`,
        },
    },
    controlsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
});

interface IUserSettingsProps {
    panelOpen?: boolean;
    setPanelOpen?: (open: boolean | ((prev: boolean) => boolean)) => void;
}

export const UserSettingsMenu: FC<IUserSettingsProps> = ({ panelOpen, setPanelOpen }) => {
    const classes = useClasses();
    const [openSettingsDialog, setOpenSettingsDialog] = useState(false);

    return (
        <div className={classes.controlsContainer}>
            {setPanelOpen && (
                <Tooltip content={panelOpen ? 'Logs panelini kapat' : 'Logs panelini aç'} relationship="label">
                    <Button
                        data-testid="logsToggleButton"
                        icon={panelOpen ? <DismissCircleRegular /> : <ClipboardCodeRegular />}
                        appearance="subtle"
                        onClick={() => {
                            setPanelOpen((prev) => !prev);
                        }}
                        className={
                            panelOpen ? mergeClasses(classes.logsButton, classes.logsButtonActive) : classes.logsButton
                        }
                        aria-label={panelOpen ? 'Developer Logs panelini kapat' : 'Developer Logs panelini aç'}
                    />
                </Tooltip>
            )}
            <SettingsDialog
                open={openSettingsDialog}
                closeDialog={() => {
                    setOpenSettingsDialog(false);
                }}
            />
        </div>
    );
};
